import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 登录页
  {
    path: '/',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },

  // 布局页
  {
    path: '/layout',
    name: 'layout',
    component: () => import('../views/Layout.vue'),
    meta: { requiresAuth: true },
    redirect: '/layout/manipulatFiles',
    children: [
      // 首页
      // {
      //   path: 'indexPage',
      //   name: 'indexPage',
      //   component: () => import('../views/IndexPage.vue')
      // },
      {
        path: 'manipulatFiles',
        name: 'manipulatFiles',
        component: () => import('../views/ManipulatFiles.vue')
      },  
      {
        path: 'changeRequire',
        name: 'changeRequire',
        component: () => import('../views/ChangeRequire.vue')
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('../views/Feedback.vue')
      },
      {
        path: 'feedForm',
        name: 'feedForm',
        component: () => import('../views/FeedForm.vue')
      },
      {
        path: 'operateMcu',
        name: 'operateMcu',
        component: () => import('../views/mcu/OperateMcu.vue')
      },  
      {
        path: 'addMcu',
        name: 'addMcu',
        component: () => import('../views/mcu/AddMcu.vue')
      },
      {
        path: 'queryMcu',
        name: 'queryMcu',
        component: () => import('../views/mcu/QueryMcu.vue')
      },
      
      {
        path: 'userList',
        name: 'userList',
        component: () => import('../views/userManage/UserList.vue')
      },
      {
        path: 'userSetting',
        name: 'userSetting',
        component: () => import('../views/userManage/UserSetting.vue')
      },      
      {
        path: 'aiDesign',
        name: 'aiDesign',
        component: () => import('../views/AI/AIDesign.vue')
      },
      
      {
        path: 'useDirections',
        name: 'useDirections',
        component: () => import('../views/UseDirections.vue')
      },
      {
        path: 'remarkManage',
        name: 'remarkManage',
        component: () => import('../views/userManage/RemarkManage.vue')
      },
      {
        path: 'createProduct',
        name: 'createProduct',
        component: () => import('../views/guide/CreateProduct.vue')
      },
      {
        path: 'projectManage',
        name: 'projectManage',
        component: () => import('../views/ProjectManage.vue')
      },
      {
        path: 'configPage',
        name: 'configPage',
        component: () => import('../views/ConfigPage.vue')
      },
      // 反馈记录
      {
        path: 'feedList',
        name: 'feedList',
        component: () => import('../views/FeedList.vue')
      },
      {
        path: 'ConfirmRequire',
        name: 'ConfirmRequire',
        component: () => import('../views/ConfirmRequire.vue')
      },
      {
        path: 'formatSdkName',
        name: 'formatSdkName',
        component: () => import('../views/FormatSdkName.vue')
      }

    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {  
  // 验证token，只有存在token时才能跳转到内容页  
  const token = sessionStorage.getItem('token')  
  if (!token && to.path !== '/login') { 
    next('/login')
  } else {  
    next()  
  }  
}) 

export default router
